import { TuningGroup } from '@/tunings/types';

const Movement: TuningGroup = {
    id: 'PlayerMovement',
    name: 'Movement',
    description: '',
    properties: [
        {
            decimals: 2,
            name: 'Lean amount',
            id: 'leanAmount',
            step: 0.05,
            default: 0.35,
        },
        {
            decimals: 2,
            description: 'Defines a player\'s walk speed',
            name: 'Walk Speed',
            id: 'speedWalk',
            step: 0.05,
            default: 2.8,
        },
        {
            decimals: 2,
            name: 'Stand Speed',
            id: 'speedStand',
            step: 0.05,
            default: 3.4,
        },
        {
            decimals: 2,
            name: 'Crouch Speed',
            id: 'speedCrouch',
            step: 0.05,
            default: 2.5,
        },
        {
            decimals: 2,
            name: 'Prone Speed',
            id: 'speedProne',
            step: 0.05,
            default: 1,
        },
        {
            decimals: 2,
            name: 'Aim Speed',
            id: 'speedAim',
            step: 0.05,
            default: 2.1,
        },
        {
            decimals: 2,
            name: 'Aim Speed Crouched',
            id: 'speedAimCrouched',
            step: 0.05,
            default: 1.75,
        },
        {
            decimals: 2,
            name: 'Aim Speed Prone',
            id: 'speedAimProne',
            step: 0.05,
            default: 0.95,
        },
        {
            decimals: 2,
            name: 'Run animation speed',
            id: 'runAnimSpeed',
            step: 0.05,
            default: 1.1,
        },
        {
            decimals: 2,
            name: 'Walk Animation Speed',
            id: 'walkAnimSpeed',
            step: 0.05,
            default: 0.6,
        },
        {
            decimals: 2,
            name: 'Feign Death Speed',
            id: 'feignSpeed',
            step: 0.05,
            default: 1.0,
        },
        {
            decimals: 2,
            name: 'Stomp Height',
            id: 'stompHeight',
            step: 0.05,
            default: 4.0,
        },
        {
            name: 'Can stomp?',
            id: 'canStomp',
            default: true,
        },
        {
            decimals: 2,
            name: 'Fall Height Death',
            id: 'fallHeightDeath',
            step: 0.05,
            default: 13.0,
        },
        {
            decimals: 2,
            name: 'Fall Height Fall',
            id: 'fallHeightFall',
            step: 0.05,
            default: 4.3,
        },
        {
            decimals: 2,
            name: 'Fall Height Crouch Modifier',
            id: 'fallHeightCrouchMod',
            step: 0.05,
            default: 2.3,
        },
        {
            decimals: 2,
            name: 'Fall Height Land',
            id: 'fallHeightLand',
            step: 0.05,
            default: 1.9,
        },
        {
            decimals: 2,
            name: 'Goomba Multiplier',
            id: 'goombaMultiplier',
            step: 0.05,
            default: 3.0,
        },
        {
            decimals: 2,
            name: 'Jump Energy Effect',
            id: 'jumpEnergyEffect',
            step: 0.05,
            default: -20.0,
        },
        {
            decimals: 2,
            name: 'Long jump max speed',
            id: 'longJumpMaxSpeed',
            step: 0.05,
            default: 5.5,
        },
        {
            decimals: 2,
            name: 'Long jump velocity multiplier',
            id: 'longJumpVelMultiplier',
            step: 0.05,
            default: 3.0,
        },
        {
            decimals: 2,
            name: 'Aim head bob modifier',
            id: 'aimBobMod',
            step: 0.05,
            default: 0.3,
        },
        {
            decimals: 2,
            name: 'Crouch head bob modifier',
            id: 'crouchBobMod',
            step: 0.05,
            default: 0.5,
        },
        {
            decimals: 2,
            name: 'Prone head bob modifier',
            id: 'proneBobMod',
            step: 0.05,
            default: 0.5,
        },
        {
            decimals: 2,
            name: 'Walk head bob modifier',
            id: 'walkBobMod',
            step: 0.05,
            default: 0.3,
        },
        {
            decimals: 3,
            name: 'Run Footstep Rate',
            id: 'runFootStepRate',
            step: 0.005,
            default: 0.315,
        },
        {
            decimals: 2,
            name: 'Walk Footstep Rate',
            id: 'walkFootStepRate',
            step: 0.05,
            default: 0.5,
        },
        {
            decimals: 2,
            name: 'Walk Sound Modifier',
            id: 'walkSoundMod',
            step: 0.05,
            default: 0.5,
        },
        {
            decimals: 2,
            name: 'Walk Volume Modifier',
            id: 'walkVolumeMod',
            step: 0.05,
            default: 0.5,
        },
        {
            decimals: 2,
            name: 'Walk Distance Modifier',
            id: 'walkDistanceMod',
            step: 0.05,
            default: 0.5,
        },
        {
            decimals: 0,
            name: 'Run Volume Modifier',
            id: 'runVolumeMod',
            step: 1,
            default: 1,
        },
        {
            decimals: 0,
            name: 'Run Distance Modifier',
            id: 'runDistanceMod',
            step: 1,
            default: 1,
        },
        {
            decimals: 2,
            name: 'Rigid Gravity',
            id: 'rigidGravity',
            step: 0.01,
            default: 9.81,
        },
        {
            name: 'Allow feign death?',
            id: 'allowFeignDeath',
            default: true,
        },
    ],
};

export default Movement;
